<template>
  <div style="padding: 20px;">
    <Row :gutter="20" style="height: 120px">
      <Col span="24" style="height: 100%">
        <block1></block1>
      </Col>
    </Row>

    <Row :gutter="20" style="margin-top: 20px">
      <Col span="6" style="height: 600px">
        <block3 style="height:280px"></block3><block7 style="height:320px;margin-top:20px"></block7> </Col
      ><Col span="18" style="height: 620px"> <block2></block2> </Col>
    </Row>

  </div>
</template>
<script>
import block1 from "./block1.vue";
import block2 from "./block2.vue";
import block3 from "../block3.vue";
import block7 from "../block7.vue";
export default {
  components: {
    block1,
    block2,
    block3,
    block7,
  },
};
</script>
<style>
.deskblock {
  width: 100%;
  height: 100%;
  background: white;
  padding: 20px;
  box-shadow: 2px 2px 4px #ccc;
}
.deskblock h3 {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/workDesk/allData/index.vue